import { stringify as qs_stringify } from 'qs'
/* 接口调用新方式 hapis */
import ajax from '@common/libs/util.ajax.js'
import Env from '@common/libs/util.env.js'
import { getQueryString } from '@common/libs/util.url.js'
import DIDA_SDK from '@common/libs/util.didasdk.js'

let domainName
if (location.host.includes(':') && /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(location.host.split(':')[0]) || location.host.includes('localhost')) {
  domainName = ''
} else {
  if (Env.isEnvOnline) {
    domainName = 'https://capis.didapinche.com'
  } else if (Env.isEnvECS) {
    domainName = 'https://capis-ecs.didapinche.com'
  } else {
    domainName = 'https://capis-test.didapinche.com'
  }
}

var longitude = '116.403847'
var latitude = '39.915526'
const minilon = getQueryString('lon') || '116.403847'
const minilat = getQueryString('lat') || '39.915526'
if (Env.inApplication) {
  // app 内
  DIDA_SDK.ready(() => {
    DIDA_SDK.callHandler('getLocation', {}).then(res => {
      if (res) {
        const obj = JSON.parse(res) || {}
        longitude = obj.lng || '116.403847'
        latitude = obj.lat || '39.915526'
      }
    }).catch(() => { })
  })
} else {
  // 非app，小程序一进入跳下载页，不用过多判断
  latitude = minilat
  longitude = minilon
}
function getNowtime () {
  const date = new Date()
  const yyyy = fomatTime(date.getFullYear())
  const MM = fomatTime(date.getMonth() + 1)
  const dd = fomatTime(date.getDate())
  const hh = fomatTime(date.getHours())
  const mm = fomatTime(date.getMinutes())
  const ss = fomatTime(date.getSeconds())
  return yyyy + MM + dd + hh + mm + ss
}

function fomatTime (num) {
  if (num < 10) {
    return '0' + num
  } else {
    return num.toString()
  }
}

// cps领取优惠券页面-领取优惠券
export function newReceiveCpsH5Coupon (data, access_token) {
  return ajax.post(domainName + '/web/activitydistribution/couponDtool/reciveCoupon', qs_stringify(data), {
    headers: {
      'x-access-token': access_token
    },
    ddcinfo: {
      // mobiletype: ''
      identifier: 'couponTemplate.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}

// 腾讯广告归因
// export function tencentattribution (data) {
//   return ajax.post(domainName + '/web/adbase/tencentattribution', qs_stringify(data), {
//     ddcinfo: {
//       identifier: 'couponTemplate.h5',
//       latitude: latitude,
//       longitude: longitude,
//       location_time: getNowtime()
//     }
//   })
// }
export function tencentattribution (data, access_token) {
  return ajax.get(domainName + '/web/adbase/tencentattribution', {
    params: data,
    headers: {
      'x-access-token': access_token
    },
    ddcinfo: {
      identifier: 'couponTemplate.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}

// 跳转小程序
export function generatescheme(data, access_token) {
  return ajax
    .get(domainName + '/web/active/wechat/generatescheme', {
      params: data,
      headers: {
        'x-access-token': access_token
      },
      ddcinfo: {
        identifier: 'couponTemplate.h5',
        latitude: latitude,
        longitude: longitude,
        location_time: getNowtime()
      }
    })
    .catch(e => {
      console.log(e)
    })
}
